export default {
  key : 'bfa37cfa6d3f640c05ac089d96a6132c',
  version: '2.0',
}